// extracted by mini-css-extract-plugin
export default {"modalContent":"FluentModal_modalContent__CSFZN"};